import React from 'react';
import { Card, CardBody, CardFooter, Row, Col, CardText } from 'reactstrap';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { Form, Field, Button } from '@cordata/buffet';

import { useExt } from '~/utils';

const initialValues = { identifierType: 'Phone' };

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  identifier: Yup.string().required(),
  identifierType: Yup.string().required(),
});

const Register = () => {
  const history = useHistory();
  const { externalActionInstance } = useParams();
  const { postIt } = useExt();

  return (
    <Form
      displayName="Register"
      validateOnBlur={false}
      validateOnChange={false}

      initialValues={initialValues}
      validationSchema={validationSchema}

      onSubmit={(values, { setSubmitting, setErrors }) => {
        postIt(values)
          .then(({ data: { message } }) => {
            toast.success(message);
            setTimeout(() => history.push(`/ext/${externalActionInstance}/register-confirm`), 1500);
          })
          .catch(({ message }) => {
            setErrors({ server: message });
            toast.error(message);
          })
          .then(() => setSubmitting(false));
      }}
    >
      {({ isSubmitting }) => (
        <Card>
          <CardBody>
            <CardText>
              Submitting referrals to requires a simple one-time registration step.{' '}
              Please enter your name and a mobile phone number that can receive a SMS message.{' '}
              Your mobile number is used only to receive authorization codes.
            </CardText>

            <Field
              name="identifierType"
              type="hidden"
              required
            />

            <Row form>
              <Col sm>
                <Field
                  name="name"
                  label="Full name"
                  placeholder="Enter full name"
                  required
                />
              </Col>

              <Col sm>
                <Field
                  name="identifier"
                  label="Telephone number"
                  type="tel"
                  placeholder="Enter telephone number"
                  required
                />
              </Col>
            </Row>
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button type="submit" disabled={isSubmitting}>
                Sav{isSubmitting ? 'ing' : 'e'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

export default Register;
